import * as XLSX from 'xlsx';

export const handleExport = (filteredFactures) => {
    //const sortedFactures = [...filteredFactures].sort((a, b) => a.id_facture - b.id_facture);
    const sortedFactures = [...filteredFactures].sort((a, b) => {
        const [aMain, aSub] = a.id_facture.split('-').map(Number);
        const [bMain, bSub] = b.id_facture.split('-').map(Number);
        if (aMain !== bMain) return aMain - bMain;
        return aSub - bSub; 
    });
    console.log("sortedFactures",sortedFactures);
    const exportData = sortedFactures.map(({ id_facture, nbrfact, currentDate, selectedorganisme, selectedHotel, montantAchat, ecart,solde,commission,comtax,tva,timbre }) => {
 
      const toExcelDate = (date) => {
        if (!(date instanceof Date)) return null;
        const excelEpoch = new Date(Date.UTC(1899, 11, 30));
        return Math.floor((date - excelEpoch) / (1000 * 60 * 60 * 24)); 
      };


        const المبلغ_المطلوب = solde;
        console.log("المبلغ_المطلوب",المبلغ_المطلوب);
        const التاريخ = toExcelDate(new Date(currentDate)); 
        const رقم_الفاتورة = id_facture;
        const رقم_فاتورة_النزل = nbrfact;
        const المؤسسة = selectedorganisme;
        const النزل = selectedHotel;
        const سعر_البيع = montantAchat; 
        const الفارق = ecart; 

        return {
            الفارق,
            سعر_البيع,
            المبلغ_المطلوب,
            التاريخ,
            رقم_فاتورة_النزل,
            النزل,
            رقم_الفاتورة,
            المؤسسة
        };
    });

    const ws = XLSX.utils.json_to_sheet(exportData);


    const numberColumns = ['A', 'B', 'C']; 
    numberColumns.forEach((column) => {
        for (let i = 1; i <= exportData.length; i++) { 
            const cellAddress = XLSX.utils.encode_cell({ r: i, c: column.charCodeAt(0) - 65 });
            if (ws[cellAddress]) {
                ws[cellAddress].z = '#,##0.000';
            }
        }
    });


    for (let i = 1; i <= exportData.length; i++) {
        const cellAddress = XLSX.utils.encode_cell({ r: i, c: 3 });
        if (ws[cellAddress]) {
            ws[cellAddress].z = 'dd/mm/yyyy';
        }
    }

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "قائمة للفاتورات المنجزة");
    XLSX.writeFile(wb, "قائمة للفاتورات المنجزة.xlsx");
};